import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { flashSelector } from 'selectors'
import styled, { css } from 'styled-components/macro'
import Icon from 'components/misc/Icon'
import { subtitle1 } from 'styles/mixins/textstyles'

const Reveal = styled.div`
  max-height: ${props => props.minimized ? '1px' : '84px'};
  overflow: hidden;
  transition: all 700ms ease;
  position: absolute;
  z-index: 15;
  width: 100%;
`

const FlashBanner = styled.div`
  background: ${props => props.theme.colors.alertBase};
  color: rgba(0,0,0,.7);
  padding: 1rem 2rem;
  text-align: center;
  font-size: 1.6rem;
  font-weight: bold;
  display: flex;
  align-items: center;

  ${props => {
    if (props.type) {
      switch(props.type) {
        case 'success': return css`background: ${props => props.theme.colors.successBase}; color: rgba(255,255,255,.8);`
        case 'error': return css`background: ${props => props.theme.colors.errorBase}; color: rgba(255,255,255,.8);`
        case 'alert': default: return css`background: ${props => props.theme.colors.alertBase};`
      }
    }
  }}
`

const FlashText = styled.div`
${subtitle1()}
  width: 100%;

  a {
    color: rgba(255,255,255, 1);
    font-weight: bold;
  }
`

const CloseButton = styled(Icon).attrs({ symbol: 'close' })`
  stroke: rgba(255,255,255,1);
  fill: none;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  margin-left: 1rem;

  &:hover {
    stroke: rgba(255,255,255,1);
    fill: none;
    stroke-width: 2;
  }
`

const Flash = props => (
  <Reveal minimized={props.minimized}>
    <FlashBanner className={props.className} type={props.type}  onClick={props.onClose}>
      <FlashText id="flash-text">{props.children}</FlashText>
      <CloseButton />
    </FlashBanner>
  </Reveal>
)

class FlashMessage extends Component {

  state = {
    minimized: true,
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      if (location.state && location.state.flash) {
        this.props.dispatch({ type: 'SET_FLASH', flash: location.state.flash })
      } else {
        this.props.dispatch({ type: 'SET_FLASH', flash: null })
      }
    })

    if (this.props.flash) {
      setTimeout(() => {
        this.setState({ minimized: false })
      }, 1)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.modalOpen && nextProps.flash && nextProps.flash.message !== (this.props.flash || {}).message) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.flash && this.props.flash) {
      setTimeout(() => {
        this.setState({ minimized: false })
      }, 1)
    } else if (prevProps.flash && !this.props.flash) {
      this.setState({ minimized: true })
    }
  }

  componentWillUnmount() {
    this.unlisten()
  }

  handleClose = event => {
    event.preventDefault()
    this.props.dispatch({ type: 'SET_FLASH', flash: null })
  }

  render() {
    const { flash, className, surpress } = this.props
    if (flash && !surpress) {
      const { message, type } = flash
      return <Flash minimized={this.state.minimized} className={className} type={type} onClose={this.handleClose}>{message}</Flash>
    }
    return null
  }

}

export default connect(flashSelector)(withRouter(FlashMessage))